<template>
  <div class="pa-4 text-center">
    <input
      ref="fileInput"
      type="file"
      accept="image/*"
      style="display: none"
      @change="onFilePicked"
    />
    <v-btn
      color="primary"
      :loading="uploading"
      :disabled="uploading"
      @click="$refs.fileInput.click()"
    >
      Choose image from computer
    </v-btn>
    <div v-if="error" class="error--text mt-3">{{ error }}</div>
    <div v-if="uploading" class="grey--text mt-3">Uploading…</div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      uploading: false,
      error: null,
    }
  },
  mounted() {
    const tab = this.$el.closest('.v-tabs')?.querySelector('.v-tab')
    if (tab) {
      tab.style.pointerEvents = 'none'
      tab.style.cursor = 'default'
    }
  },
  methods: {
    async onFilePicked(event) {
      const file = event.target.files && event.target.files[0]
      event.target.value = ''
      if (!file) return

      this.error = null
      this.uploading = true

      try {
        const payload = new FormData()
        payload.append('file', file)

        const response = await this.$api.post('media', payload, {
          headers: { 'Content-Type': 'multipart/form-data' },
        })

        const url = response.data.data.responsive_url
        this.$emit('select-file', { src: url, alt: file.name })
      } catch (e) {
        this.error =
          (e.response && e.response.data && e.response.data.message) ||
          'Upload failed. Please try again.'
      } finally {
        this.uploading = false
      }
    },
  },
}
</script>
